import angular from 'angular';

import * as Configuration from '../../app.constants.js';


angular
  .module('notifications.controller', [])
  .constant('TRIES_BEFORE_DISCONNECT', 3)
  .controller('NotificationsController', NotificationsController);

NotificationsController.$inject = ['loggedUser','$timeout','$scope', '$state', '$stateParams', '$rootScope', 'NotificationsFactory', '$interval', 'TRIES_BEFORE_DISCONNECT','LoginFactory'];
function NotificationsController(loggedUser,$timeout,$scope, $state, $stateParams,$rootScope,NotificationsFactory,$interval, TRIES_BEFORE_DISCONNECT, LoginFactory) {
  
  init();

  $scope.markAsReadAllNotifications = markAsReadAllNotifications;
  $scope.getUnseenNotifications = getUnseenNotifications;
  $scope.markAsSeen = markAsSeen;
  $scope.goToNotification = goToNotification;

  function markAsSeen(notificationId) {
    NotificationsFactory.readNotification($stateParams.companyId, 'self', notificationId).then(function() {
      $scope.unseenNotificationsCount = ($scope.unseenNotificationsCount > 0) ? $scope.unseenNotificationsCount - 1 : 0;

      let indexOfNotificationToRemove = $scope.notificationsIds.indexOf(notificationId);
      if (indexOfNotificationToRemove > -1) {
        $scope.notificationsIds.splice(indexOfNotificationToRemove, 1);
      }
      //Adding animation
      angular.element('#notif-'+notificationId).addClass('remove');
      $timeout(function(){
        delete $scope.notifications[notificationId];
      },500);

      if(Object.keys($scope.notifications).length === 0){
        $scope.alertBox = false;
      }
    });
  }

  function init() {
    $scope.baseUrl = Configuration.constants.baseUrl;
    $scope.companyId = $stateParams.companyId;
    $scope.loadingNotifications = false;
    $scope.notifications = {};
    $scope.notificationsIds = [];
    $scope.unseenNotificationsCount = 0;
    $scope.loggedUser = loggedUser;

    const unsubscribeFn = $rootScope.$on('ws.user.notification', getUnseenNotifications);
    $scope.$on('$destroy', function() {
      unsubscribeFn();
    });
    $timeout(getUnseenNotifications, 1000); // let's not slow down the app init with yet another XHR

    //set up interaction with sidenav
    NotificationsFactory.setOpenNotificationsFn(openNotifications);
    $scope.$watch('unseenNotificationsCount', newCount => {
      NotificationsFactory.updateUnseenNotificationsCount(newCount);
    });
  }


  function openNotifications() {
    $scope.alertBox = !$scope.alertBox;
  }


  function markAsReadAllNotifications () {
    NotificationsFactory.markAsReadAllNotifications($stateParams.companyId,'self').then(function(data) {
      $scope.unseenNotificationsCount = 0;
      $scope.notifications = {};
      $scope.notificationsIds = [];
      $scope.alertBox = false;
    });
  }

  function getUnseenNotifications() {
    if($scope.loadingNotifications === true) {
      return;
    }
    $scope.loadingNotifications = true;
    NotificationsFactory.getNotifications($stateParams.companyId,'self',{params:{'is_seen':0, 'auto':1}})
      .then(function(response) {
        $scope.notifications = response.data;
        angular.forEach(response.data, function(notification) {
          if ($scope.notificationsIds.indexOf(notification.id) == -1) {
            $scope.notificationsIds.push(notification.id);
          }
        });
        let calculatedUnseenNotifications = Object.keys($scope.notifications).length;
        $scope.unseenNotificationsCount = calculatedUnseenNotifications;
        $scope.loadingNotifications = false;
      }, 
      (e) => console.error('error while getting notifications', e)
    );
  }

  function goToNotification(notificationId) {
    const url = $scope.baseUrl + $scope.companyId + '/notification/' + notificationId;
    LoginFactory.redirectWithJwtShort(url);
  }
}

export default NotificationsController;
